const API_URL = process.env.REACT_APP_API_URL;
const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;

export const LOGIN_ENDPOINT = LOGIN_URL + "/oauth/token";

export const PERSONA_ENDPOINT = API_URL + "datosPersonales";
export const NOTAS_ENDPOINT = API_URL + "notas";
export const NOTAS_AVG_ENDPOINT = API_URL + "notas/avg";
export const PROGRAMA_ALUMNO_ENDPOINT = API_URL + "programaAlumno";
export const CURSO_INSCRIPCIONES_ENDPOINT = API_URL + "curso/inscripciones";
export const INSCRIPCION_CURSO_ENDPOINT =
  API_URL + "curso/cursosDisponiblesParaInscripcion";
export const INSCRIPCION_CURSO_PDF_ENDPOINT = API_URL + "curso/cursosPdf";
export const INSCRIPCION_FECHA_EXAMEN_ENDPOINT = API_URL + "curso/fechaExamen";
export const INSCRIPCION_FINAL_ENDPOINT = API_URL + "mesa";
export const INSCRIPCION_FINAL_PDF_ENDPOINT = API_URL + "mesa/finalesPdf";
export const INICIO_TRAMITE_ENDPOINT = API_URL + "tramiteAlumno";
export const INICIO_TRAMITE_TIPO_ENDPOINT =
  API_URL + "tramiteAlumno/tipoTramite";
export const INICIO_TRAMITE_ENDPOINT_MATERIAS =
  API_URL + "tramiteAlumno/materias";
export const INICIO_TRAMITE_ENDPOINT_MATERIAS_TRAMITE =
  API_URL + "tramiteAlumno/materiasTramite";
export const PAIS = API_URL + "pais";
export const PROVINCIA = API_URL + "provincia";
export const LOCALIDAD = API_URL + "localidad";
export const DEUDA = API_URL + "deuda";
export const EXTERNAL_LINK = API_URL + "deuda/externalLink";
export const HISTORICO_INSCRIPCION_FINAL_ENDPOINT =
  API_URL + "mesa/inscripciones";
export const RECUPERAR_CLAVE = API_URL + "credenciales/recupero";
export const ACTUALIZAR_CLAVE = API_URL + "credenciales/cambio";
export const CERTIFICADO = API_URL + "certificadoExamen";
export const ALUMNO_REGULAR = API_URL + "alumno/home/alumnoRegular";
export const DEACARGAR_CERTIFICADO_ALUMNO_REGULAR =
  API_URL + "alumno/home/certificadoPdf";
